/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList";
import themeConfig from "@/../themeConfig.js";
import colors from "@/../themeConfig.js";

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
	uid: 0, // From Auth
	fullname: "Agri Index", // From Auth
	email: "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
	photoURL: "https://sangiaodich.comayplus.com/themes/cm-sgd-22/partials/favicon.png", // From Auth
	status: "online",
	userRole: "admin",
	isManager: false
};

const userInfoLocalStorage = JSON.parse(localStorage.getItem("userInfo")) || {};
// Set default values for active-user
// More data can be added by auth provider or other plugins/packages
const getUserInfo = () => {
	let userInfo = {};

	// Update property in user
	Object.keys(userDefaults).forEach(key => {
		// If property is defined in localStorage => Use that
		userInfo[key] = userInfoLocalStorage[key] ? userInfoLocalStorage[key] : userDefaults[key];
	});

	// Include properties from localStorage
	Object.keys(userInfoLocalStorage).forEach(key => {
		if (userInfo[key] == undefined && userInfoLocalStorage[key] != null) userInfo[key] = userInfoLocalStorage[key];
	});

	return userInfo;
};

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
	AppActiveUser: getUserInfo(),
	bodyOverlay: false,
	isVerticalNavMenuActive: true,
	mainLayoutType: themeConfig.mainLayoutType || "vertical",
	navbarSearchAndPinList: navbarSearchAndPinList,
	reduceButton: themeConfig.sidebarCollapsed,
	verticalNavMenuWidth: "default",
	verticalNavMenuItemsMin: false,
	scrollY: 0,
	starredPages: navbarSearchAndPinList["pages"].data.filter(page => page.is_bookmarked),
	theme: themeConfig.theme || "light",
	themePrimaryColor: colors.primary,

	// Can be used to get current window with
	// Note: Above breakpoint state is for internal use of sidebar & navbar component
	windowWidth: null,
	listProvince: [],
	listDistrict: [],
	listWard: []
};

export default state;
